// Booking Card Component
import { formatThaiDate } from './calendar.js';
import { t } from '../i18n.js';

const STATUS_MAP = {
  get pending() { return { label: t('status_pending'), class: 'badge-pending' }; },
  get paid() { return { label: t('status_paid'), class: 'badge-pending' }; },
  get confirmed() { return { label: t('status_confirmed'), class: 'badge-confirmed' }; },
  get cancelled() { return { label: t('status_cancelled'), class: 'badge-cancelled' }; },
  get completed() { return { label: t('status_completed') || 'ดูเสร็จแล้ว', class: 'badge-confirmed' }; }
};

const SERVICE_MAP = {
  get onsite() { return { icon: '🏠', label: t('service_onsite').replace('🏠 ', '') }; },
  get chat() { return { icon: '💬', label: t('service_chat').replace('💬 ', '') }; },
  get call() { return { icon: '📞', label: t('service_call').replace('📞 ', '') }; },
  get video() { return { icon: '📹', label: t('service_video').replace('📹 ', '') }; }
};

export function renderBookingCard(booking, options = {}) {
  const { showActions = false, onApprove, onReject, onCancel } = options;
  const status = STATUS_MAP[booking.status] || STATUS_MAP.pending;
  const service = SERVICE_MAP[booking.service_type] || { icon: '🔮', label: booking.service_type || 'บริการดูดวง' };

  return `
    <div class="card booking-card" data-booking-id="${booking.id}">
      <div class="card-header">
        <div class="card-avatar-wrap" style="position:relative">
          <span style="font-size:2.5rem">${service.icon}</span>
        </div>
        <div class="card-info">
          <h3>${t('card_title')}</h3>
          <p>${service.label} · ${formatThaiDate(booking.date)}</p>
          <p class="text-xs text-muted">${booking.time}</p>
        </div>
        <span class="badge ${status.class}">${status.label}</span>
      </div>
      ${booking.customer_name ? `
        <div class="card-body">
          <p><strong>${t('lbl_customer')}</strong> ${booking.customer_name}</p>
          ${booking.price_tier ? `<p class="text-sm mt-xs"><strong style="color:var(--accent-gold);">รูปแบบ:</strong> ${booking.price_tier}</p>` : ''}
          ${booking.price ? `<p class="text-sm mt-xs"><strong style="color:var(--accent-gold);">ยอดชำระ:</strong> ฿${booking.price.toLocaleString()}</p>` : ''}
          ${booking.phone ? `<p class="text-sm mt-xs"><strong>เบอร์โทร:</strong> <a href="tel:${booking.phone}" style="color:var(--accent-gold); text-decoration:none;">${booking.phone}</a></p>` : ''}
          ${booking.note ? `<p class="mt-xs text-sm"><strong>${t('lbl_note')}</strong> ${booking.note}</p>` : ''}
          
          ${booking.line_name ? `
          <div class="mt-sm" style="display:flex; align-items:center; gap:8px; background:rgba(0,185,0,0.05); padding:8px; border-radius:8px; border:1px solid rgba(0,185,0,0.2);">
            <img src="${booking.line_picture || 'https://ui-avatars.com/api/?name=L'}" style="width:30px; height:30px; border-radius:50%; object-fit:cover;" />
            <div>
               <p class="text-xs text-muted" style="margin:0; line-height:1;">ติดต่อผ่าน LINE</p>
               <p class="text-sm fw-600" style="margin:0; color:#00B900;">${booking.line_name}</p>
            </div>
          </div>
          ` : ''}

          ${booking.customer_details ? `
          <div class="mt-sm pt-sm" style="border-top: 1px dashed var(--border);">
            <p class="text-sm"><strong>เพศ:</strong> ${booking.customer_details.gender || '-'} <strong>ส่วนสูง:</strong> ${booking.customer_details.height || '-'}</p>
            <p class="text-sm"><strong>ว/ด/ป:</strong> ${formatThaiDate(booking.customer_details.dob)} <strong>เวลา:</strong> ${booking.customer_details.tob || '-'}</p>
            <p class="text-sm"><strong>จังหวัดเกิด:</strong> ${booking.customer_details.pob || '-'}</p>
            <p class="text-sm"><strong>คำถาม:</strong> ${booking.customer_details.question || '-'}</p>
            <div class="mt-xs" style="display:flex; gap:8px; flex-wrap:wrap; margin-top:8px;">
              ${booking.customer_details.face_photo_urls && booking.customer_details.face_photo_urls.length > 0 
                  ? booking.customer_details.face_photo_urls.map((url) => `<img src="${url}" style="width:60px; height:60px; object-fit:cover; border-radius:8px; border:1px solid var(--border); cursor:pointer;" onclick="let w=window.open('','_blank'); w.document.write('<img src=\\'${url}\\' style=\\'max-width:100%; max-height:100vh;\\'/>');" title="คลิกเพื่อดูรูปใหญ่" />`).join('')
                  : (booking.customer_details.face_photo_url ? (
                      booking.customer_details.face_photo_url.startsWith('data:') 
                      ? `<img src="${booking.customer_details.face_photo_url}" style="width:60px; height:60px; object-fit:cover; border-radius:8px; border:1px solid var(--border); cursor:pointer;" onclick="let w=window.open('','_blank'); w.document.write('<img src=\\'${booking.customer_details.face_photo_url}\\' style=\\'max-width:100%; max-height:100vh;\\'/>');" title="คลิกเพื่อดูรูปใหญ่" />`
                      : `<a href="${booking.customer_details.face_photo_url}" target="_blank" class="text-primary text-xs" style="text-decoration:underline;">📸 ดูรูปหน้าตรง</a>`
                    ) : '')}
            </div>
          </div>
          </div>
          ` : ''}

          ${showActions ? `
          <div class="mt-sm" style="display:flex; gap:8px;">
             <button class="btn btn-sm btn-outline booking-msg-btn text-xs" data-id="${booking.id}" data-userid="${booking.user_id}" style="flex:1; color:#00B900; border-color:#00B900; background:rgba(0,185,0,0.05);">
                💬 ส่งข้อความจากระบบ
             </button>
             <a href="${options.line_oa_bot_id ? `https://chat.line.biz/${options.line_oa_bot_id}/chat/${booking.user_id}` : 'https://chat.line.biz/'}" target="_blank" onclick="${!options.line_oa_bot_id ? `alert('⚠️ กรุณาไปที่เมนู \\'ตั้งค่าระบบ\\' (Settings) แล้วกรอก \\'LINE OA Provider ID\\' (ขึ้นต้นด้วย U...) เพื่อให้ระบบสามารถเปิดหน้าแชทของลูกค้าแต่ละคนได้ตรงคนครับ'); return true;` : ''}" class="btn btn-sm btn-outline text-xs" style="flex:1; color:#00B900; border-color:#00B900; background:rgba(0,185,0,0.05);">
                🔗 เปิด LINE OA
             </a>
          </div>
          ` : ''}
        </div>
      ` : ''}
      ${showActions && booking.status === 'pending' ? `
        <div class="card-footer">
          <button class="btn btn-sm btn-primary booking-approve-btn" data-id="${booking.id}">✅ อนุมัติ</button>
          <button class="btn btn-sm btn-danger booking-reject-btn" data-id="${booking.id}">❌ ปฏิเสธ</button>
        </div>
      ` : ''}
      ${showActions && booking.status === 'confirmed' ? `
        <div class="card-footer">
          <button class="btn btn-sm booking-complete-btn" style="background:#00B900; color:#fff;" data-id="${booking.id}">✅ ดูดวงเสร็จสิ้น</button>
        </div>
      ` : ''}
      ${!showActions ? `
        <div class="card-footer" style="flex-wrap: wrap; gap: var(--space-xs);">
          ${booking.status === 'pending' ? `<span class="text-xs text-muted" style="flex:1; align-self:center;">⏳ รอแอดมินยืนยัน...</span>` : ''}
          ${(booking.status === 'pending' || booking.status === 'confirmed') ? `<button class="btn btn-sm btn-outline booking-cancel-btn" data-id="${booking.id}">${t('btn_cancel_booking')}</button>` : ''}
        </div>
      ` : ''}
    </div>
  `;
}

export function bindBookingActions(container, callbacks = {}) {
  if (callbacks.onApprove) {
    container.querySelectorAll('.booking-approve-btn').forEach(btn => {
      btn.addEventListener('click', () => callbacks.onApprove(btn.dataset.id));
    });
  }
  if (callbacks.onReject) {
    container.querySelectorAll('.booking-reject-btn').forEach(btn => {
      btn.addEventListener('click', () => callbacks.onReject(btn.dataset.id));
    });
  }
  if (callbacks.onComplete) {
    container.querySelectorAll('.booking-complete-btn').forEach(btn => {
      btn.addEventListener('click', () => callbacks.onComplete(btn.dataset.id));
    });
  }
  if (callbacks.onCancel) {
    container.querySelectorAll('.booking-cancel-btn').forEach(btn => {
      btn.addEventListener('click', () => callbacks.onCancel(btn.dataset.id));
    });
  }
  if (callbacks.onSendMessage) {
    container.querySelectorAll('.booking-msg-btn').forEach(btn => {
      btn.addEventListener('click', () => callbacks.onSendMessage(btn.dataset.id, btn.dataset.userid));
    });
  }
}
